module.exports = __webpack_public_path__ + "static/img/introduction-img.dc5c844.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/introduction-img.png
// module id = Oqfo
// module chunks = 1